import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-5">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 font-label text-xs text-foreground-500">
        <li>
          <Link to="/" className="cursor-pointer transition-colors hover:text-primary-600">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-2">
            <span className="flex h-3 w-3 items-center justify-center text-foreground-300">
              <i className="ri-arrow-right-s-line" aria-hidden="true" />
            </span>
            {item.to && index < items.length - 1 ? (
              <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}